<div class="g-layout__container strategy">
    <div class="strategy__header">
        <div class="strategyhHeader__container">
            <div class="strategyhHeader__svg" [routerLink]="['/strategy']">
                @if(dir=='rtl'){

                <i class="pi pi-angle-right g-c-primaryDarkerColor text-xl"></i>
                }@else {

                <i class="pi pi-angle-left g-c-primaryDarkerColor text-xl"></i>
                }
            </div>
            <p class="font-bold g-c-primaryDarkerColor">
                {{+strategyId>0?('edite strategy'|translate):'add_new_strategy'|translate}}
                :
                @if(strategyId)
                {
                <span class="mx-2">
                    {{strategyFormData.name}}
                </span>
                }
            </p>
        </div>
    </div>
    <div class="br"></div>
    <div class="form__container">
        
        <!-- Current Default Strategy Info -->
        <div class="info-box">
            <i class="fa-solid fa-circle-info"></i>
            <span>{{"The current default strategy is"|translate}}: <strong>{{defualtStrategy?.name}}</strong></span>
        </div>

        <form (ngSubmit)="submit()" #strategyForm="ngForm">
            <!-- Two Column Grid Layout -->
            <div class="form-grid">
                <!-- Name Field -->
                <div class="form-control">
                    <label class="form-label" for="name">{{'strategy_name'|translate}}</label>
                    <input pInputText id="name" [(ngModel)]="strategyFormData.name" name="name" #name="ngModel" ngModel
                        required aria-describedby="username-help" />
                </div>
                
                <!-- Name English Field -->
                <div class="form-control">
                    <label class="form-label" for="name_en">{{'name_in_english'|translate}}</label>
                    <input pInputText id="name_en" [(ngModel)]="strategyFormData.name_en" name="name_en" #name_en="ngModel" ngModel
                        aria-describedby="username-help" />
                </div>
                
                <!-- Default Strategy Radio Buttons -->
                <div class="form-control">
                    <label class="form-label">{{"Set strategy as default"|translate}}</label>
                    <small class="helper-text">{{"Setting a strategy as default overrides the default of the others"|translate}}</small>
                    <div class="radio-group">
                        <div class="radio-item">
                            <p-radioButton ngModel [(ngModel)]="is_default" name="is_default" [value]=true
                                inputId="yesId" />
                            <label for="yesId">{{'yes'|translate}}</label>
                        </div>
                        <div class="radio-item">
                            <p-radioButton ngModel [(ngModel)]="strategyFormData.is_default" name="is_default" [value]=false
                                inputId="noId" />
                            <label for="noId">{{'no'|translate}}</label>
                        </div>
                    </div>
                </div>
                
                <!-- Vision Field -->
                <div class="form-control">
                    <label class="form-label">{{'Vision'|translate}}</label>
                    <textarea rows="4" ngModel #vision="ngModel" [(ngModel)]="strategyFormData.vision" required
                        name="vision" pInputTextarea></textarea>
                </div>
                
                <!-- Mission Field -->
                <div class="form-control">
                    <label class="form-label">{{"the message"|translate}}</label>
                    <textarea rows="4" ngModel [(ngModel)]="strategyFormData.mission" #message="ngModel" name="mission"
                        required pInputTextarea></textarea>
                </div>
            </div>

            <form #dateForm="ngForm" appDateRangeValidator
                [dateRange]="{ startDate: 'start_date', endDate: 'end_date' }">
                <div class="calander_parent">
                    <div class="form-control">
                        <label class="form-label">{{'start_date'|translate}}</label>
                        <p-calendar [(ngModel)]="strategyFormData.start_date" required ngModel #start_date="ngModel"
                            name="start_date" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" />
                    </div>
                    <div class="form-control">
                        <label class="form-label">{{'end_date'|translate}}</label>
                        <p-calendar [(ngModel)]="strategyFormData.end_date" required ngModel #end_date="ngModel"
                            name="end_date" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" />
                    </div>
                </div>
            </form>


            <div class="form-actions">
                <button type="button" class="back-btn" [routerLink]="['/strategy']">
                    <i class="fa-solid fa-arrow-right" *ngIf="dir=='rtl'"></i>
                    <i class="fa-solid fa-arrow-left" *ngIf="dir=='ltr'"></i>
                    <span>{{'back'|translate}}</span>
                </button>
                <p-button [disabled]="strategyForm.invalid||dateForm.invalid" type="ngSubmit"
                    label="{{'Go_to_Pillars'|translate}}" [raised]="true"></p-button>
            </div>
        </form>
    </div>
</div>